import { defineFcm } from '../shared/factory';

export const FCM_STARFISH_HOMEPAGE_TO_SAP_DRAFT_V1 = defineFcm('starfish_homepage_to_sap_draft_v1')
	.asBoolean()
	.withDefault(false)
	.toConfig();
